import React from 'react';
import { useNavigate } from 'react-router-dom';

const Home = () => {
  const navigate = useNavigate();

  return (
    <div style={styles.page}>
      {/* Soft layered pastel background shapes */}
      <div style={styles.backgroundLayer1}></div>
      <div style={styles.backgroundLayer2}></div>
      <div style={styles.backgroundLayer3}></div>

      <header style={styles.header}>
        <h1 style={styles.title}>Smart Camera Frame Demo</h1>
        <p style={styles.subtitle}>Capture, Frame, and Share – All in One Click.</p>
      </header>

      <main style={styles.main}>
        <section style={styles.section}>
          <h2 style={styles.sectionTitle}>About This Demo</h2>
          <p style={styles.sectionText}>
            This web app demonstrates an interactive and mobile-optimized camera experience with real-time framing and one-click sharing to popular social platforms.
            Designed with simplicity and elegance in mind, it lets users:
          </p>
          <ul style={styles.bulletList}>
            <li>📷 Access camera instantly</li>
            <li>🖼️ Overlay a custom frame</li>
            <li>💾 Download or 📤 Share the photo</li>
            <li>📱 Fully mobile optimized</li>
          </ul>
          <button
            onClick={() => navigate('/camera')}
            style={styles.ctaButton}
            onMouseEnter={(e) => (e.target.style.background = '#a6d4c5')}
            onMouseLeave={(e) => (e.target.style.background = 'linear-gradient(135deg, #b8e0d2 0%, #f0f9f4 100%)')}
          >
            Launch Camera
          </button>
        </section>

        <section style={styles.section}>
          <h2 style={styles.sectionTitle}>Use Cases</h2>
          <p style={styles.sectionText}>
            Perfect for events, marketing campaigns, branded frames, or social sharing tools integrated into your platform.
          </p>
        </section>
      </main>

      <footer style={styles.footer}>
        © 2025 Soluzent. All rights reserved.
      </footer>
    </div>
  );
};
const styles = {
  page: {
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif",
    minHeight: '100vh',
    color: '#4a4a4a',
    position: 'relative',
    overflow: 'hidden',
    backgroundColor: '#f5f7f6',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '3rem 1rem',
  },

  /* layered pastel circles and shapes for subtle vintage layering */
  backgroundLayer1: {
    position: 'fixed',
    top: '-10%',
    left: '-15%',
    width: '300px',
    height: '300px',
    borderRadius: '50%',
    background: 'radial-gradient(circle at center, #ffe6e6, transparent 70%)',
    zIndex: -3,
  },
  backgroundLayer2: {
    position: 'fixed',
    bottom: '-15%',
    right: '-10%',
    width: '400px',
    height: '400px',
    borderRadius: '50%',
    background: 'radial-gradient(circle at center, #d4f0e9, transparent 70%)',
    zIndex: -2,
  },
  backgroundLayer3: {
    position: 'fixed',
    top: '40%',
    right: '-5%',
    width: '200px',
    height: '200px',
    borderRadius: '40% 60% 60% 40% / 60% 40% 60% 40%',
    background: 'radial-gradient(circle at center, #fdf9f5, #f0f9f4)',
    boxShadow: '0 0 20px 6px rgba(184, 224, 210, 0.3)',
    zIndex: -1,
  },

  header: {
    textAlign: 'center',
    marginBottom: '2rem',
    maxWidth: '600px',
    padding: '1rem 2rem',
    backgroundColor: '#fff',
    borderRadius: '16px',
    boxShadow: '0 6px 18px rgba(0,0,0,0.07)',
  },
  title: {
    fontWeight: 700,
    fontSize: '2.8rem',
    letterSpacing: '0.05em',
    color: '#5a3e56',
    margin: '0 0 0.5rem',
    fontFamily: "'Playfair Display', serif",
  },
  subtitle: {
    fontWeight: 400,
    fontSize: '1.2rem',
    color: '#7d6f7d',
    fontStyle: 'italic',
  },

  main: {
    maxWidth: '700px',
    width: '100%',
    backgroundColor: '#fff',
    borderRadius: '20px',
    padding: '2.5rem 3rem',
    boxShadow: '0 12px 30px rgba(0,0,0,0.05)',
  },
  section: {
    marginBottom: '2.5rem',
  },
  sectionTitle: {
    fontSize: '1.8rem',
    marginBottom: '1rem',
    color: '#5a3e56',
    fontWeight: '600',
    borderBottom: '3px solid #b8e0d2',
    paddingBottom: '0.3rem',
    letterSpacing: '0.05em',
  },
  sectionText: {
    fontSize: '1.05rem',
    lineHeight: 1.6,
    color: '#6e5a6e',
    marginBottom: '1rem',
  },
  bulletList: {
    textAlign: 'left',
    color: '#6e5a6e',
    paddingLeft: '1.3rem',
    marginBottom: '1.8rem',
    fontSize: '1.1rem',
    lineHeight: 1.5,
  },

  ctaButton: {
    background: 'linear-gradient(135deg, #b8e0d2 0%, #f0f9f4 100%)',
    border: 'none',
    color: '#4a4a4a',
    fontWeight: '600',
    fontSize: '1.1rem',
    padding: '0.85rem 2rem',
    borderRadius: '12px',
    cursor: 'pointer',
    boxShadow: '0 4px 15px rgba(184, 224, 210, 0.5)',
    transition: 'background 0.3s ease, transform 0.25s ease',
    userSelect: 'none',
  },

  footer: {
    marginTop: 'auto',
    padding: '1.2rem',
    textAlign: 'center',
    fontSize: '0.9rem',
    color: '#999',
    fontWeight: '500',
    letterSpacing: '0.03em',
  },
};

export default Home;

// Make sure to import and use this Home component in your App.js routes
// and keep your styles object as you already have it.
